import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { auth } from "./firebase";

import MenuCameriere from "./CameriereMenu/MenuCameriere";
import DashboardCameriere from "./DashboardCameriere";
import WaiterSetup from "./WaiterSetup";
import SplashWaiter from "./SplashWaiter";

function PostConfigScreen({ onContinue }) {
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  const deferredPrompt = window.__WAITER_INSTALL_PROMPT;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #0f0f12 0%, #18181c 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1.5rem",
        color: "#fff"
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "360px",
          textAlign: "center",
          padding: "2rem",
          borderRadius: "28px",
          background: "rgba(255,255,255,0.04)",
          backdropFilter: "blur(12px)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
          border: "1px solid rgba(255,255,255,0.06)"
        }}
      >
        {/* ICONA */}
        <div
          style={{
            width: "72px",
            height: "72px",
            margin: "0 auto 1.2rem",
            borderRadius: "20px",
            background: "linear-gradient(135deg, #0a84ff, #5ac8fa)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "34px"
          }}
        >
          ✓
        </div>

        {/* TITOLO */}
        <h2
          style={{
            margin: 0,
            fontSize: "1.4rem",
            fontWeight: 600,
            marginBottom: "0.6rem"
          }}
        >
          Configurazione completata
        </h2>

        {/* DESCRIZIONE */}
        <p
          style={{
            fontSize: "0.9rem",
            color: "#aaa",
            marginBottom: "1.8rem",
            lineHeight: 1.4
          }}
        >
          Il cameriere è pronto.<br />
          Installa l'app per lavorare più velocemente.
        </p>

        {/* INSTALL BUTTON */}
        {!isStandalone && (
          <button
            disabled={!deferredPrompt}
            onClick={async () => {
              if (!deferredPrompt) return;

              deferredPrompt.prompt();
              const choice = await deferredPrompt.userChoice;

              if (choice.outcome === "accepted") {
                window.location.reload();
              }
            }}
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "16px",
              border: "none",
              background: "linear-gradient(135deg, #0a84ff, #007aff)",
              color: "#fff",
              fontWeight: "600",
              fontSize: "0.95rem",
              marginBottom: "10px",
              cursor: deferredPrompt ? "pointer" : "not-allowed",
              opacity: deferredPrompt ? 1 : 0.4,
              boxShadow: "0 8px 25px rgba(10,132,255,0.4)"
            }}
          >
            📲 Installa app
          </button>
        )}

        {/* CONTINUA */}
        <button
          onClick={onContinue}
          style={{
            width: "100%",
            padding: "14px",
            borderRadius: "16px",
            border: "1px solid rgba(255,255,255,0.08)",
            background: "rgba(255,255,255,0.04)",
            color: "#fff",
            fontSize: "0.9rem",
            cursor: "pointer"
          }}
        >
          Continua
        </button>
      </div>
    </div>
  );
}

function DashboardCameriereWrapper() {
  const localeTag = localStorage.getItem("waiter_locale");
  const cameriereId = localStorage.getItem("waiter_id");
  const justConfigured = localStorage.getItem("waiter_just_configured");

  if (justConfigured === "true") {
    return (
      <PostConfigScreen
        onContinue={() => {
          localStorage.removeItem("waiter_just_configured");
          window.location.reload();
        }}
      />
    );
  }

  if (!localeTag || !cameriereId) {
    return <WaiterSetup />;
  }

  return (
    <DashboardCameriere
      localeTag={localeTag}
      cameriereId={cameriereId}
    />
  );
}

function AppWaiter() {
  const [authReady, setAuthReady] = useState(false);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const localeFromUrl = params.get("locale");

    if (localeFromUrl) {
      localStorage.setItem("waiter_locale", localeFromUrl);

      // pulisce URL dopo aver salvato
      window.history.replaceState({}, document.title, "/");
    }
  }, []);

  // 🔵 intercetta installazione PWA Android
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log("📲 PWA install prompt disponibile");
      window.__WAITER_INSTALL_PROMPT = e;
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      try {
        if (!u) {
          await signInAnonymously(auth);
        }
      } catch (e) {
        console.error("❌ signInAnonymously error:", e);
      } finally {
        setAuthReady(true);
      }
    });

    return () => unsub();
  }, []);


  if (!authReady || showSplash) {
    return <SplashWaiter onReady={() => setShowSplash(false)} />;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<DashboardCameriereWrapper />} />
        <Route path="/waiter" element={<DashboardCameriereWrapper />} />
        <Route path="/menu-cameriere" element={<MenuCameriere />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default AppWaiter;